export default __webpack_public_path__ + "static/media/table.fba700ab.png";